// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sAEU","questions":"styles_questions__DGcvz","footer":"styles_footer__1Synp"};